// A phone number in the form the server stores it (PhoneNormalizer.normalize):
// digits only, with a US/Canada leading 1 dropped from an 11-digit number. Used
// by the Trust Center wizard's Ready Gate to compare the field against the
// verified number and to check for 10 digits (PhoneNumberValidator), #18683.
export function phoneDigits(value) {
  const digits = String(value || "").replace(/\D/g, "")
  return digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits
}
